import React, { Component } from "react";
import { Card, Container, InputGroup, Button } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
//import "../../../css/AddReceiptStyles.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";

const divStyle = {
  width: "100%",
  maxHeight: "calc(25vh)",
  margin: "5px",
  //border: '5px solid black'
};

export default class AddPalletGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      columnDefs: this.createColumnDefs(),
      gridData: [],
      // editorModalShowing: this.props.modalClosed
    };
    this.dataReady = false;
    this.onGridReady = this.onGridReady.bind(this);
    this.refreshGridData = this.refreshGridData.bind(this);
  }



  refreshGridData() {
    this.setState({
      isLoading: true,
    });
    var gridDataResponse = this.props.rowData.pallets;
    if (this.props.rowData.pallets !== null) {
      this.setState({
        gridData: gridDataResponse,
        isLoading: false,
      });
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.dataReady = true;
  }

  createColumnDefs() {
    /*
    var modelScaffold = new AddReceiptLinePalletEditorModel();
    var modelDefs = Object.getOwnPropertyNames(modelScaffold);
    var columnDefs = [];
    var hideCol = false;
    modelDefs.forEach((el) => {
      columnDefs.push({ headerName: el, field: el, hide: hideCol});
    });
    */
   var columnDefs = [
    {headerName: "Id", field: "glasschainId", sortable: false, filter: false, resizable: true, maxWidth: 100},
    {headerName:  "Qty", field: "actualPalletUnitQty", sortable: true, filter: false, resizable: true, maxWidth: 100, type: "numericColumn"}
   ];
    return columnDefs;
  }

  render() {
    if (this.dataReady) {
      this.gridApi.setRowData((this.props.rowData) ? this.props.rowData.pallets : []);
    }

    return (
      <span>
        <Card style={{maxWidth: "33vw", minWidth: "25vw"}}>
          <Card.Header style={{display: "-webkit-inline-flex", padding: "0"}}>
          <span style={{minWidth: "max-content", paddingTop: "15px", paddingLeft: "10px"}}>
              Pallets
            </span>
            <Container fluid style={{paddingTop: "15px"}}>
              <InputGroup size="sm">
                <p data-tip="Open Pallet Editor for Current Line">
                  <Button
                    size="sm"
                    variant="outline-info"
                    onClick={this.props.onRequestPalletEditor}
                    id="pallet-editor-btn"
                  >
                    <FontAwesomeIcon icon={faFileExport} />
                    &nbsp;Editor
                  </Button>
                </p>
              </InputGroup>
            </Container>
          </Card.Header>
          <Card.Body style={{padding: "0"}}>
            <div style={{ width: "100%", height: "100%" }}>
              <Container fluid>
                <div className="ag-theme-balham" style={divStyle}>
                  <AgGridReact
                    rowSelection="single"
                    //enableRangeSelection={true}
                    //pagination={false}
                    flex="true"
                    columnDefs={this.state.columnDefs}
                    rowData={(this.props.rowData) ? this.props.rowData.pallets: []}
                    // selectedRow = {this.state.selectedRow}
                    //animateRows={true}
                    onGridReady={this.onGridReady}
                    //onSelectionChanged={this.onSelectionChanged}
                    domLayout='autoHeight'
                  />
                </div>
              </Container>
            </div>
          </Card.Body>
        </Card>
      </span>
    );
  }
}
